import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import { htmlTextAnchorParser } from '../../../utils'

class Toggle extends React.Component {
  state = {}

  static getDerivedStateFromProps(props, state) {
    if (state.checked !== undefined) {
      return {}
    }
    return { checked: props.value }
  }

  render() {
    const { className, label, captions } = this.props
    const { checked } = this.state

    // If the label is too long display the toggle in a new line.
    // Fix for issue https://agile.sensory-minds.com/issue/JTITOPGT-5070/4910-INC4568058-Issue-with-ContactConsent1-field
    const labelSize = label.length > 48 ? 12 : 4

    return (
      <Grid container className={className} direction={'row'}>
        <Grid xs={labelSize} item container alignItems={'center'}>
          <Typography>{htmlTextAnchorParser(label)}</Typography>
        </Grid>
        <Grid xs={8} item container alignItems={'center'}>
          <FormControlLabel
            control={
              <Switch
                checked={this.state.checked}
                onChange={() => this.setState({ checked: !checked })}
              />
            }
            label={captions[checked ? 1 : 0]}
          />
        </Grid>
      </Grid>
    )
  }

  checkValidity = () => !this.props.required || this.state.checked

  getValue = () => this.state.checked
}

// this is necessary, otherwise 'innerRef'ing this Component in FormElementsGroup will not work
export default withStyles({})(Toggle)
